module.exports = __webpack_public_path__ + "img/vip_page.75abe042.png";